import type {
  UpdateQuestionnaireTemplateInput,
  UpdateQuestionnaireTemplateMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Maps the TRPC mutation response to match the GraphQL mutation structure.
 */
const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): UpdateQuestionnaireTemplateMutation => {
  return {
    updateQuestionnaireTemplateApi: {
      __typename: 'IdOutput',
      Id: trpcData.Id,
    },
  };
};

export const useUpdateQuestionnaireTemplateTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.questionnaireTemplate.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.questionnaireTemplate.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.questionnaireTemplate.getById.queryKey(),
        });
      },
    }),
  });

  return {
    updateQuestionnaireTemplate: async (
      variables: UpdateQuestionnaireTemplateInput
    ): Promise<UpdateQuestionnaireTemplateMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
